import { temporarilyNotSupport } from '../../utils'

// 相机
export const createCameraContext = temporarilyNotSupport('createCameraContext')
